import { render } from "./SidebarNavItem.vue?vue&type=template&id=c16ef7be&scoped=true&ts=true"
import script from "./SidebarNavItem.vue?vue&type=script&lang=ts"
export * from "./SidebarNavItem.vue?vue&type=script&lang=ts"

import "./SidebarNavItem.vue?vue&type=style&index=0&id=c16ef7be&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c16ef7be"]])

export default __exports__